import { Polyline } from "react-leaflet";

export default function EmergencyRouteLayer({ coordinates, color }) {
  return (
    <Polyline
      positions={coordinates}
      color={color}
      weight={3}
      dashArray={'1,5'}
      interactive={false}
    >
    </Polyline>
  );
}